import * as React from 'react';
import type { CalendarDayContentConfig } from '../interfaces/CalendarDayConfig';
import { observer } from 'mobx-react-lite';
import CalendarDefaultSurfaceComponent from './CalendarDefaultSurfaceComponent';

let styles = require('./CalendarDayList.scss');

/**
 * Props for calendar grid
 */
export interface CalendarGridProps {
    contentConfig: CalendarDayContentConfig;
}

/**
 * The control is showing in day events on grid.
 */
export default observer(function CalendarGrid(props: CalendarGridProps) {
    let { contentConfig } = props;
    let surfaceItems = contentConfig.content.content();
    let gridLineRows = contentConfig.content.gridLines();

    const { component, additionalProps } = contentConfig.inDayContentComponent || {};
    const InDayContentComponentType = component || CalendarDefaultSurfaceComponent;

    return (
        <InDayContentComponentType className={styles.renderPanel} additionalProps={additionalProps}>
            {gridLineRows}
            {surfaceItems}
        </InDayContentComponentType>
    );
});
